export const EXHIBITOR_TITLE = 'Brand';
export const PRODUCT_TITLE = 'Offer';
export const COUNTRY_TITLE = 'Market';
